// useIncognitoCheck.ts
import { useCallback, useRef } from "react";
import { detectIncognito } from "detectincognitojs";

export type IncognitoResult = {
  isPrivate: boolean;
  browserName: string | null;
};

export function useIncognitoCheck() {
  const cached = useRef<IncognitoResult | null>(null);
  const inflight = useRef<Promise<IncognitoResult> | null>(null);

  const check = useCallback(
    async (opts?: { force?: boolean }): Promise<IncognitoResult> => {
      // return cached result unless force=true
      if (cached.current && !opts?.force) return cached.current;
      if (inflight.current && !opts?.force) return inflight.current;

      const p = (async () => {
        const r = await detectIncognito();
        const result: IncognitoResult = {
          isPrivate: !!r.isPrivate,
          browserName: r.browserName ?? null,
        };
        cached.current = result;
        return result;
      })().finally(() => {
        inflight.current = null; // clear the in-flight promise once settled
      });

      inflight.current = p;
      return p;
    },
    []
  );

  return check; // call: await check()
}
